import { api } from "api";

// export interface LoginResponse {
//   contact: string;
//   firstName: string;
//   lastName: string;
//   refreshToken: string;
//   accessToken: string;
//   networkCode: string;
//   hasError?: boolean;
// }

export interface ProfileOpenidAccessToken {
  token?: string;
  refreshToken?: string;
  scope?: string;
  token_type?: string;
  expires_in?: number;
  ssoType?: string
}

export interface ProfileOpenidIdTokenClaimsAddress {
  country?: string;
  street_address?: string;
  locality?: string;
  postal_code?: string;
}

export interface ProfileOpenidIdTokenClaims {
  sub?: string;
  address?: ProfileOpenidIdTokenClaimsAddress;
  sAMAccountName?: string;
  given_name?: string;
  locale?: string;
  siret?: string;
  organization?: string;
  phone_number?: string;
  mobile_number?: string;
  family_name?: string;
  email?: string;
  preferred_language?: string; // "fr-FR",
  username?: string;
}

export interface ProfileOpenidIdToken {
  token?: string;
  claims?: ProfileOpenidIdTokenClaims;
}


export interface ProfileOpenidData {
  accessToken?: ProfileOpenidAccessToken;
  idToken?: ProfileOpenidIdToken;

}
export interface ProfileData {
  address1?: string;
  city?: string;
  postalcode?: string;
  phone?: string;
  email?: string,
  externalId?: string;
  persona?: number;
  businessSector?: string;
}

export interface ProfileResponse {
  //contact: string;
  //firstName: string;
  //lastName: string;

  entities?: string;
  id?: number;
  username?: string;
  email?: string;
  active?: boolean;
  jwttoken?: string;
  role?: string;
  preferedLang?: string; //"en",
  siret?: string;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: string,
  updatedAt?: string;

  openid_data?: ProfileOpenidData;
  data?: ProfileData;
}

// export const loginRequest = ({
//   code,
//   language,
//   isInternal,
// }: {
//   code: string;
//   language: string;
//   isInternal: boolean;
// }) => {
//   return api.post<{ redirectUrl: string }>("account/login", null, {
//     params: { culture: language, code, isInternal },
//   });
// };

// export const loginWithCodeRequest = ({
//   code,
//   state,
// }: {
//   code: string;
//   state: string;
// }) => {
//   return api.post<LoginResponse>(
//     "account/loginCode",
//     { Code: code, State: state },
//     {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     }
//   );
// };

export const getProfileRequest = () => {
  return api.get<ProfileResponse>("auth/userinfos");
};



